/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    UtilityActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchTimezonesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_FETCH_TIMEZONES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UtilityActions.receiveTimezones))
);

export const fetchUrlInfoEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_URL_INFO_FETCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, UtilityActions.receiveUrlInfo))
);

export const fetchCountriesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_FETCH_COUNTRIES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UtilityActions.receiveCountries))
);

export const fetchRegionsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_FETCH_REGIONS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, UtilityActions.receiveRegions))
);

export const fetchFavoritesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_FETCH_FAVORITES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, UtilityActions.receiveFavories))
);

export const fetchRelatedHashtagsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.UTILITIES_FETCH_RELATED_HASHTAGS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, UtilityActions.receiveRelatedHashtags))
);
